const CustomButton =({children})=>(
    <button className="focus:outline-none bg-red-700 transition-all duration-300 transform hover:scale-95 rounded px-12 py-2 font-medium text-center text-white">{children}</button>
)

export default CustomButton;